import { render, staticRenderFns } from "./PigNewData.vue?vue&type=template&id=559a2e7c"
import script from "./PigNewData.vue?vue&type=script&lang=js"
export * from "./PigNewData.vue?vue&type=script&lang=js"
import style0 from "./PigNewData.vue?vue&type=style&index=0&id=559a2e7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports